<template>
<div class="mb-2">
	<form v-for="(setting,settingIndex) in settings" class="card" style="clear: both;margin-bottom: 10px;" v-on:submit.prevent="saveCollectiveAgreement(setting)">
		<h3 class="card-header">
			<input v-if="!setting.readonly" type="text" class="form-control" v-model="setting.title">
			<span v-else>{{setting.title}}</span>

			<div class="header-buttons text-right">
				<button v-if="setting.readonly && setting.archived == 0" class="btn btn-light btn-sm" type="button" v-on:click="editMode(setting,settingIndex)">
					<i class="fa fa-pencil-alt"></i>
					Edit
				</button>

				<button v-if="setting.readonly && setting.archived == 0" class="btn btn-light btn-sm" type="button" v-on:click="toggleArchiveColAgr(true,setting,settingIndex)">
					<i class="fa fa-archive"></i>
					Archive
				</button>

				<button v-else-if="setting.readonly && setting.archived == 1" class="btn btn-light btn-sm" type="button" v-on:click="toggleArchiveColAgr(false,setting,settingIndex)">
					<i class="fa fa-archive"></i>
					Un-Archive
				</button>

				<button v-else-if="'id' in setting" class="btn btn-light btn-sm" type="button" v-on:click="cancelEdit(settingIndex)">
					<i class="fa fa-times"></i>
					Cancel
				</button>
				
				<!--<i class="fa fa-trash" v-on:click="deleteSettingGroup(setting)"></i>-->
			</div>
		</h3>
		<div v-if="setting.archived == 0" class="card-body">

			<div v-if="setting.is_default == 1" class="alert alert-secondary default-alert-flag">
				This is the default Compensation Schedule
			</div>
			<button v-else-if="!setting.readonly && 'id' in setting" class="btn btn-light mb-2" type="button" v-on:click="setDefault(setting)">
				Set as default Compensation Schedule
			</button>

			<div class="text-muted">
				<p>
					<template v-if="setting.created_at">Created on {{ formatDateTimeToLocal(setting.created_at) }}.</template>
					<template v-if="setting.updated_at">Updated {{ formatDateTimeToLocal(setting.updated_at) }}
						<template v-if="setting.UpdatedBy"> by {{setting.UpdatedBy.first_name}} {{setting.UpdatedBy.last_name}}</template>.
					</template>
				</p>

				<p v-if="setting.expiry_date && setting.readonly">Set to expire on {{formatDateTimeToLocal(setting.expiry_date,'full-date')}}</p>
			</div>

			<div v-if="setting.readonly">
				<a v-if="!setting.expanded" href="#" v-on:click.prevent="setting.expanded = true"><i class="fa fa-chevron-down"></i> Expand details...</a>
				<p v-else-if="setting.expanded"><a href="#" v-on:click.prevent="setting.expanded = false"><i class="fa fa-chevron-up"></i> Hide details...</a></p>
			</div>

			<template v-if="setting.expanded">

				<field v-if="!setting.readonly"
					label="Expiry"
					col-class="col-auto"
					:readonly="setting.readonly"
					:params="{type:'date'}"
					v-model="setting.expiry_date">
				</field>

				<accordion heading="Per Diems">

					<div class="row">
						<div class="col-md-6">
							<field label="Per Diem $" 
								:readonly="setting.readonly"
								col-class="col-md-4" 
								:params="{type: 'number',min:0,max:10000,step:1}" 
								v-model="setting.per_diem">
							</field>
						</div>
						<div class="col-md-6">
							<field :label="'Per Diems Paid Above ('+regionalDistanceUnit+')'" 
								:readonly="setting.readonly"
								col-class="col-md-6" 
								:params="{type: 'number',min:0,max:10000,step:5}" 
								v-model="setting.per_diem_range">
							</field>
						</div>
					</div>

				</accordion>

				<accordion heading="Mileage Settings">

					<field label="Mileage Calculation Method"
						:readonly="setting.readonly"
						col-class="col-lg-4 col-md-6"
						:params="{type:'select',options:mileageMethodOptions}"
						v-model="setting.use_zone_mileage">
					</field>

					<template v-if="setting.use_zone_mileage == 0">

						<div class="d-flex flex-row flex-wrap align-items-center mb-2">
							<span class="mr-2">Mileage activates when distance from </span>
							<field v-if="!setting.readonly" class="mr-2" 
								:params="{type:'select',options:mileageActivationPlaces}"
								v-model="setting.mileage_trigger_address">
							</field>
							<strong v-else> {{ getMileageTriggerAddressLabel(setting.mileage_trigger_address) }} </strong>
							<span class="mr-1 ml-1"> is greater than </span>
							<field v-if="!setting.readonly" 
								class="mr-2" 
								style="width: 70px;" 
								:params="{type:'number'}"
								v-model="setting.mileage_trigger_distance">
							</field>
							<strong v-else>{{ setting.mileage_trigger_distance }}</strong>
							<span class="ml-1"> {{regionalDistanceUnit}}.</span>
							<!--<span class="mr-2 ml-2">The first </span>
							<field class="mr-2"
								style="width: 70px;" 
								:readonly="setting.readonly"
								:params="{type:'number',step:1,min:0}"
								v-model="setting.mileage_deductable">
							</field>
							<span>km will not be paid</span>-->
						</div>

						<div class="d-flex flex-row flex-wrap align-items-center mb-2">
							<span class="mr-2">The first </span>
							<field class="mr-2"
								style="width: 70px;" 
								:readonly="setting.readonly"
								:params="{type:'number',step:0.5,min:0}"
								v-model="setting.mileage_deductable">
							</field>
							<span>{{regionalDistanceUnit}} will not be paid (mileage deductable).</span>
						</div>

						<div class="row">

							<div class="col-lg-6">
								<field label="Distance Calculation Method" 
									:readonly="setting.readonly"
									col-class="col-md-5" 
									:params="{type:'select',options:combinedDistanceMethodOptions}" 
									v-model="setting.distance_calculation_method">
								</field>
							</div>

							<div class="col-lg-6">
								<field label="Use One Way Distance on Rate Payouts" 
									:readonly="setting.readonly"
									col-class="col-md-8"
									:control-left='true' 
									:params="{type:'boolean'}" 
									v-model="setting.distance_is_one_way">
								</field>
							</div>
							
						</div>	

						<section v-for="(tier,index) in setting.mileage_settings" class="tier-section" :class="{readonly: setting.readonly}">
							
							<div class="tier-section-field">
								<label class="mb-0 mr-2">Max {{regionalDistanceUnit}}</label>
								<field  
									class="tier-section-control"
									:readonly="setting.readonly"
									:params="{type:'number',min:0,max:10000,step:1}" 
									v-model="tier.max_km">
								</field>
							</div>
							<div class="tier-section-field">
								<label class="mb-0 mr-2">Payout Type</label>
								<field
									class="tier-section-control"
									:readonly="setting.readonly"
									:params="{type:'select',options:[
										{text: 'Flat Payout',value:'flat'},{text: 'Rate Per '+regionalDistanceUnit,value:'rate'}]
									}" 
									v-model="tier.payout_type">
								</field>
							</div>
							<div class="tier-section-field">
								<label class="mb-0 mr-2">{{tier.payout_type == 'rate' ? 'Rate $/'+regionalDistanceUnit : 'Amount $'}}</label>
								<field
									class="tier-section-control"
									:readonly="setting.readonly"
									:params="{type:'number',min:0,step:0.001}" 
									v-model="tier.rate">		
								</field>
							</div>
							<div>
								<i v-if="!setting.readonly" v-on:click="removeTier(settingIndex,index)" class="fa fa-times fa-2x remove-tier-btn" style="margin-top: 2px;color: #455A64"></i>
							</div>

						</section>

						<button v-if="!setting.readonly" type="button" class="btn btn-primary float-right" v-on:click="addTier(settingIndex)">
							<i class="fa fa-plus"></i>
							Add Tier
						</button>
					</template>
					<template v-else-if="setting.use_zone_mileage == 1">
						<div v-for="(zone,zoneIndex) in setting.mileage_zones_json" class="d-flex flex-row tier-section">

							<div class="tier-section-field">
								<label class="mb-0 mr-2">Zone Label</label>
								<field
									v-model="zone.label"
									:readonly="setting.readonly">
								</field>
							</div>
							<div class="tier-section-field">
								<label class="mb-0 mr-2">Pay</label>
								<field
									:params="{type:'number',min:0,step:0.01}"
									:readonly="setting.readonly"
									v-model="zone.pay">
								</field>
							</div>
							<div>
								<i v-if="!setting.readonly" v-on:click="removeZone(settingIndex,zoneIndex)" class="fa fa-times fa-2x remove-tier-btn" style="margin-top: 2px;color: #455A64"></i>
							</div>
						</div>
						<button v-if="!setting.readonly" class="btn btn-success" v-on:click="addZone(settingIndex)" type="button">
							<i class="fa fa-plus"></i>
							Add Zone
						</button>
					</template>

					<div style="clear: both;"></div>
				</accordion>
				
				<accordion heading="Pay Rates">
					<div class="alert alert-info">You can over-ride default wages by adding it to the list and changing the rate.</div>

					<draggable v-model="setting.pay_scales" >
						<section v-for="(rate, index) in setting.pay_scales" class="rate-section d-flex align-items-center" :class="{readonly: setting.readonly}" v-if="!setting.readonly || rate.classification_id > 0">

							<i v-if="rate.classification_id > 0 && !setting.readonly" class="fa fa-sort fa-fw drag-handle icon-button"></i>
							<div class="rate-fields-container mr-2">
								<div class="row align-items-center">
									<div class=" col-lg-4 col-md-12">
										<div v-if="rate.classification_id > 0" style="font-weight: 600;font-size: 14pt;">
											{{ classificationOptions.find(opt => opt.value == rate.classification_id) ? classificationOptions.find(opt => opt.value == rate.classification_id).text : "" }}
										</div>
										<field v-else
											:readonly="setting.readonly"
											label="Classification"
											col-class="col-auto"
											:params="{type:'select',
												options:classificationOptions.filter(opt => !setting.pay_scales.find(rate => rate.classification_id == opt.value)),
												placeholder:'Choose a classification...'}"
											v-model="rate.classification_id">
										</field>
									</div>
									<!--<div class="col-lg-3">
										<field label="Hourly Rate" col-class="col-md-6" :params="{type:'number',min:0,step:0.001}"
										v-model="rate.hourly_rate"></field>
									</div>-->
									<div class="col-lg-8 col-md-12">
										<form-group label="Hourly Rate" class="align-items-center" col-class="col-lg-4 col-xl-3">
											<!--<field :params="{type:'number',min:0,step:0.001}" v-model="rate.cost_hr"></field>-->

											<div class="d-flex flex-row">

												<field 
													:readonly="setting.readonly"
													v-model="rate.cost_hr" 
													:params="{type: 'number', step: 0.01, min: 0,placeholder:'Reg. Time'}">
													<label class="text-muted">
														Reg. Time
													</label>
												</field>

												<field
													v-if="timeLogSettings.uses_overtime_15x == 1"
													:readonly="setting.readonly"
													v-model="rate.ot15_cost_hr" 
													:params="{type: 'number', step: 0.01, min: 0,placeholder:'OT 1.5x'}">
													<label class="text-muted">
														OT 1.5x
													</label>
												</field>

												<field 
													v-if="timeLogSettings.uses_overtime_2x == 1"
													:readonly="setting.readonly"
													v-model="rate.ot2_cost_hr" 
													:params="{type: 'number', step: 0.01, min: 0,placeholder:'OT 2x'}">
													<label class="text-muted">
														OT 2x
													</label>
												</field>

												<field 
													v-if="timeLogSettings.uses_overtime_25x == 1"
													:readonly="setting.readonly"
													v-model="rate.ot25_cost_hr" 
													:params="{type: 'number', step: 0.01, min: 0,placeholder:'OT 2.5x'}">
													<label class="text-muted">
														OT 2.5x
													</label>
												</field>
										
											</div>

										</form-group>
									</div>

								</div>
							</div>
							<i v-if="!setting.readonly" v-on:click="removePayscale(settingIndex,index)" class="fa fa-times icon-button remove-payscale-btn" style="margin-top: 2px;color: #455A64"></i>
						</section>
					</draggable>

					<button v-if="!setting.readonly" type="button" class="btn btn-primary float-right" v-on:click="addPayscale(settingIndex)">
						<i class="fa fa-plus"></i>
						Add Pay Rate
					</button>

					<div style="clear: both;"></div>
					<hr>
				</accordion>

				<p v-if="!moveToUnionVisible && !setting.readonly"><a href="#" v-on:click.prevent="moveToUnionVisible= true">Assign to a different compensation group/union...</a></p>

				<div v-if="moveToUnionVisible" class="mt-2">
					<field label="Compensation Group" 
						col-class="col-md-2 col-sm-3" 
						:params="{type:'select',options:unionsOptions}" 
						v-model="setting.union_id">
					</field>
					<p class="text-muted">Click save to finish moving it to a new compensation group/union</p>
				</div>

				<button v-if="!setting.readonly" class="btn btn-success float-right" type="submit">
					<i class="fa fa-save"></i>
					Save Compensation Schedule
				</button>

				<!--<button v-if="!setting.readonly" type="button" class="btn btn-outline-danger" v-on:click="deleteSettingGroup(setting)">
					<i class="fa fa-trash"></i>
					Delete Compensation Schedule
				</button>-->

				<a v-if="!setting.readonly" href="#" class="text-danger" v-on:click.prevent="deleteSettingGroup(setting)">
					<i class="fa fa-trash"></i>
					Delete Compensation Schedule...
				</a>
			</template>
		</div>
		
	</form>

	<button type="button" class="btn btn-primary float-right" v-on:click="addSettingGroup">
		<i class="fa fa-plus"></i>
		Add Compensation Schedule
	</button>

	<modal-dialog
		:modal-visible="confirmDialog.visible"
		title="Delete Collective Agreement"
		confirm-button-text="<i class='fa fa-trash'></i> Yes, Delete"
		button-class="btn-outline-danger"
		v-on:confirm="confirmDeleteSettingGroup"
		v-on:closeModal="confirmDialog.visible = false">

		<template v-if="confirmDialog.visible">Delete the <strong>{{confirmDialog.collectiveAgreement.title}}</strong> Compensation Schedule?</template>

	</modal-dialog>

	<modal-dialog
		:modal-visible="editConfirmDialog.visible"
		title="Edit Collective Agreement"
		confirm-button-text="Yes, Edit"
		button-class="btn-success"
		v-on:confirm="proceedWithEdit"
		v-on:closeModal="editConfirmDialog.visible = false">

		<div class="text-center">
			<h5>Editing a compensation schedule will affect historical records</h5>

			<p>If you wish to update a compensation schedule with new terms, you should create a copy, and archive this one, by clicking the "Update Terms" button below.</p>

			<button class="btn btn-primary mb-2" v-on:click="copyAndArchive">
				<i class="fa fa-copy"></i>
				Update Terms
			</button>

			<p><strong>Are you sure you want to edit?</strong></p>
		</div>

	</modal-dialog>	

	<slot></slot>			
</div>
</template>

<script>

import VueForm from "../VueForm"
import Field from "../Field"
import ModalDialog from "../ModalDialog"
import FormGroup from "@/components/FormGroup"
import Accordion from "@/components/Accordion"
import draggable from 'vuedraggable'


export default {

	name: 'CollectiveAgreementsComponent',
	components: {
		VueForm,
		Field,
		ModalDialog,
		FormGroup,
		Accordion,
		draggable
	},
	props: ["selectedUnion","collectiveAgreements","unions","employeeClassifications","timeLogSettings","companyAddresses","isWizardInstance"],
	data() {
		return {
			readonly: true,
			settings: [],
			confirmDialog: {
				visible: false,
				collectiveAgreement: null
			},
			editConfirmDialog: {
				visible: false,
				setting: {},
				index: null
			},
			moveToUnionVisible: false,
			mileageMethodOptions:[
				{text: 'Point to point distance (default)',value:'0'},
				{text: "Zones",value:'1'}
			],
			distanceMethodOptions: [
				{text: "Distance from Home",value:'home'},
				{text: "Distance from Office",value:'office'},
				{text: "Closest Distance from Home or Office",value:'closest'},
				{text: "Furthest Distance from Home or Office",value:'furthest'}
			]
		}
	},
	watch: {
		collectiveAgreements() {
			this.setSettings()
		}
	},
	computed: {
		regionalDistanceUnit() {
			if (this.companyIsAmerican)
				return "mi"

			return "km"
		},
		combinedDistanceMethodOptions() {
			return this.distanceMethodOptions.concat(this.companyAddressOptions)
		},
		mileageActivationPlaces() {
			let places = [
				{text: "Employee Home",value:'home'},
				{text: "Office",value: "office"}
			]

			places = places.concat(this.companyAddressOptionsWithoutFrom)

			return places
		},
		companyAddressOptionsWithoutFrom() {
			return this.optionify(this.companyAddresses,"place_name")
		},
		companyAddressOptions() {
			return this.optionify(this.companyAddresses.map(addr => {
				addr.addr = "From "+addr.place_name
				return addr
			}),"addr")
		},
		unionsOptions() {
			return this.optionify(this.unions,"union_name")
		},
		classificationOptions() {
			return this.optionify(this.employeeClassifications,"title")
		}
	},
	methods: {
		getMileageTriggerAddressLabel(addressValue) {
			if (addressValue == 'home' || addressValue == 'office')
				return addressValue
			else {
				let optionSelected = this.companyAddressOptionsWithoutFrom.find(option => option.value == addressValue)
				if (optionSelected)
					return optionSelected.text
			}
			return ""
		},
		/*resortMileageTiers(tiers) {
			tiers = tiers.sort((a,b) => {
				if (parseFloat(a.max_km) > parseFloat(b.max_km))
					return 1
				return -1
			})
		},*/
		addSettingGroup() {
			this.settings.push({
				title: "[New Group]",
				per_diem: 0,
				per_diem_range: 0,
				union_id: this.selectedUnion.id,
				mileage_settings: [],
				pay_scales: [],
				readonly: false,
				expanded: true,
				archived: 0
			})
		},
		cancelEdit(index) {
			this.settings[index].readonly = true
		},
		deleteSettingGroup(setting) {
			this.confirmDialog.visible = true
			this.confirmDialog.collectiveAgreement = setting
		},
		confirmDeleteSettingGroup() {
			let vm = this

			let payload = {
				id: this.confirmDialog.collectiveAgreement.id
			}

			this.postData("CollectiveAgreement/delete",payload).then(respons => {
				vm.confirmDialog.visible = false
				vm.alertSuccess("Collective Agreement Deleted")

				vm.$emit("modelChange")
			})
		},
		addTier(settingIndex) {
			if (!this.settings[settingIndex].mileage_settings)
				this.settings[settingIndex].mileage_settings = []

			this.settings[settingIndex].mileage_settings.push({
				payout_type: 'rate',
				max_km: 0,
				rate: 0
			})

			this.$forceUpdate()
		},
		addZone(settingIndex) {
			if (!this.settings[settingIndex].mileage_zones_json)
				this.settings[settingIndex].mileage_zones_json = []

			this.settings[settingIndex].mileage_zones_json.push({
				label: "[New Zone]",
				pay: 0,
			})

			this.$forceUpdate()
		},
		addPayscale(settingIndex) {
			let vm = this

			if (!this.settings[settingIndex].pay_scales)
				this.settings[settingIndex].pay_scales = []

			this.settings[settingIndex].pay_scales.push({
				classification_id: null,
				hourly_rate: null,
				cost_hr: null
			})

			this.$forceUpdate()
		},
		removeTier(settingIndex,index) {
			this.settings[settingIndex].mileage_settings.splice(index,1)
		},
		removeZone(settingIndex,index) {
			this.settings[settingIndex].mileage_zones_json.splice(index,1)
		},
		removePayscale(settingIndex,index) {
			this.settings[settingIndex].pay_scales.splice(index,1)
		},
		setDefault(ca) {
			let vm = this

			if ("id" in ca) {
				this.saveRecord("CollectiveAgreement",{id: ca.id, is_default: 1}, response => {
					vm.alertSuccess("Default set")
					vm.$emit("modelChange")
				})
			}
		},
		saveCollectiveAgreement(setting) {
			let vm = this

			let per_diem_range_km = setting.per_diem_range
			let mileage_trigger_distance_km = setting.mileage_trigger_distance
			let mileage_settings_km = setting.mileage_settings
			let mileage_deductable_km = setting.mileage_deductable
			if (this.companyIsAmerican) {
				per_diem_range_km = +setting.per_diem_range * 1.61
				mileage_trigger_distance_km = +setting.mileage_trigger_distance * 1.61				
				mileage_deductable_km = setting.mileage_deductable * 1.61

				mileage_settings_km = this.cloneObj(setting.mileage_settings)
				mileage_settings_km.forEach(tier => {
					tier.max_km = +tier.max_km * 1.61
				})
			}

			let payload = {
				id: setting.id,
				title: setting.title.trim(),
				per_diem: setting.per_diem,
				per_diem_range: per_diem_range_km,
				mileage_trigger_address: setting.mileage_trigger_address,
				mileage_trigger_distance: mileage_trigger_distance_km,
				use_zone_mileage: setting.use_zone_mileage,
				mileage_zones_json: JSON.stringify(setting.mileage_zones_json),
				union_id: setting.union_id,
				mileage_settings: JSON.stringify(mileage_settings_km),
				pay_scales: JSON.stringify(setting.pay_scales),
				mileage_deductable: mileage_deductable_km,
				expiry_date: setting.expiry_date
			}

			if (!isNaN(setting.distance_calculation_method)) {
				payload.distance_calculation_method = "custom-address"
				payload.start_address_id = setting.distance_calculation_method
			}
			else 
				payload.distance_calculation_method = setting.distance_calculation_method

			this.$emit("saveCollectiveAgreement")

			this.postData("CollectiveAgreement/save",payload,true).then(response => {
				if (response.success) {
					vm.alertSaved("Changes saved")
					setting.readonly = true
					setting.expanded = true
					setting.archived = 0
					setting.id = response.record_id
				}
			})
		},
		setSettings() {
			let vm = this
			let cas = JSON.parse(JSON.stringify(this.collectiveAgreements))

			this.settings = cas.map(setting => {

				if (typeof setting.mileage_settings == 'string') {
					if (setting.mileage_settings == "" || setting.mileage_settings == "[]")
						setting.mileage_settings = []
					else
						setting.mileage_settings = JSON.parse(setting.mileage_settings)
				}

				if (typeof setting.pay_scales == 'string') {
					if (setting.pay_scales == "")
						setting.pay_scales = []
					else
						setting.pay_scales = JSON.parse(setting.pay_scales)
				}

				if (typeof setting.mileage_zones_json == 'string') {
					if (setting.mileage_zones_json == "")
						setting.mileage_zones_json = []
					else
						setting.mileage_zones_json = JSON.parse(setting.mileage_zones_json)
				}

				setting.readonly = true
				setting.expanded = false

				//distances are stored in km, so we need to convert to mi for display if company is american
				if (vm.companyIsAmerican) {
					setting.per_diem_range = +setting.per_diem_range / 1.61
					setting.mileage_trigger_distance = +setting.mileage_trigger_distance / 1.61				
					setting.mileage_deductable = +setting.mileage_deductable / 1.61

					setting.mileage_settings.forEach(tier => {
						tier.max_km = +tier.max_km / 1.61
					})
				}

				return setting
			})

		},
		toggleArchiveColAgr(archive,setting,index) {
			let vm = this

			let archiveValue = 1
			if (!archive)
				archiveValue = 0

			return new Promise((resolve,reject) => {
				vm.postData("CollectiveAgreement/save",{id: setting.id,archived:archiveValue},true).then(response => {
					if (response.success) {

						let state = "archived";
						if (!archive) 
							state = "un-archived";

						vm.alertSaved("Collective Agreement "+state)
						setting.archived = archiveValue
						vm.settings.splice(index,1)
					}

					resolve(response)
				})
				
			})
		},

		editMode(setting,index) {
			if (this.isWizardInstance) {
				this.editConfirmDialog.visible = false
				this.editConfirmDialog.setting = setting
				this.editConfirmDialog.index = index
				this.proceedWithEdit()
			}
			else {
				this.editConfirmDialog.visible = true
				this.editConfirmDialog.setting = setting
				this.editConfirmDialog.index = index
			}

		},
		proceedWithEdit() {
			this.editConfirmDialog.setting.readonly = false
			this.editConfirmDialog.visible = false
			this.editConfirmDialog.setting.expanded = true
		},
		copyAndArchive() {
			let vm = this

			let newCA = JSON.parse(JSON.stringify(this.editConfirmDialog.setting))

			newCA.title += " [Copy]"
			delete newCA.id

			this.settings.splice(this.editConfirmDialog.index,0,newCA)

			vm.saveCollectiveAgreement(newCA)

			this.toggleArchiveColAgr(true,this.editConfirmDialog.setting,this.editConfirmDialog.index+1).then(response => {
				if (response.success) {
					vm.settings[vm.editConfirmDialog.index].readonly = false
				}
			})

		},
		/*fetchData() {
			let vm = this

			let caFilter = ""
			if (this.unionOnlyId) {
				caFilter = "?filters="+JSON.stringify([
					['union_id',this.unionOnlyId]
				])
			}

			let promises = [
				this.getJSON("CollectiveAgreement/get"+caFilter),
				this.getJSON("EmployeeClassification/get"),
				this.getJSON("Union/get")
			]

			this.spinner(true)

			Promise.all(promises).then(responses => {
				vm.spinner(false)

				if (responses[0].success) {

					vm.settings = responses[0].data.map(setting => {

						if (setting.mileage_settings == "")
							setting.mileage_settings = []
						else
							setting.mileage_settings = JSON.parse(setting.mileage_settings)

						if (setting.pay_scales == "")
							setting.pay_scales = []
						else
							setting.pay_scales = JSON.parse(setting.pay_scales)

						return setting
					})

				}

				vm.classifications = responses[1].data
				vm.classificationOptions = vm.optionify(responses[1].data,"title")

				vm.unions = responses[2].data

			})
		}*/
	},
	created() {
		if (this.collectiveAgreements) 
			this.setSettings()

		if (this.isWizardInstance && this.settings.length == 0)
			this.addSettingGroup()
	}

}
</script>

<style type="text/css" scoped>
	.schedule-section-heading {
		text-decoration: none;
		background: #bf9e40;
		color: white;
		padding: 10px;
		cursor: pointer;
		margin-top: 10px;
	}

	.schedule-section-heading:hover {
		opacity: 0.7
	}

	.tier-section, .rate-section {
		background-color: #f1f5f7;
		padding: 10px;
		border-radius: 5px;
		margin-top: 5px;
		margin-bottom: 5px;
		position: relative;
	}

	.tier-section {
		display: flex;
		flex-direction: row;
		align-items: center;
	}

	.tier-section.readonly, .rate-section.readonly {
		padding-top: 5px;
	}

	.tier-section-field {
		margin-right: 10px;
		display: flex;
		align-items: center;
		flex-direction: row;
	}

	.card-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.card h3.card-header {
		margin: 0;
		flex-grow: 1
	}

	h3 input.form-control {
		border: none;
		padding-left: 0;
		font-size: 16pt;
		box-shadow: none;
		background-color: transparent;
		width: 100%;
	}

	h3 input.form-control:hover, h3 input.form-control:focus {
		
		border: 1px solid #ced4da;
		padding-left: .375rem;
		font-size: 16pt;
		background-color: white;
		margin-left: -6px;
		margin-top: -2px;
	}

	.card-header .header-buttons {
		width: 220px;
	}

	.card-header .fa-trash {
		font-size: 22pt;
		color: red;
		cursor: pointer;
	}

	.card-header .fa-trash:hover {
		opacity: 0.5
	}

	.rate-fields-container {
		width: calc(100% - 35px);
		display: inline-block;
		vertical-align: top;
	}

	.remove-payscale-btn,
	.remove-tier-btn {
		margin-left: 5px;
		cursor: pointer;
	}

	.drag-handle {
		cursor: pointer;
	}

	.default-alert-flag {
		margin: -21px;
		margin-bottom: 15px;
		border-radius: 0;
	}

	@media (max-width: 991px) {

		.tier-section-field {
			display: block;
		}

		.rate-fields-container {
			width: 100%;
		}

		.remove-payscale-btn {
			position: absolute;
			top: 10px;
			right: 10px;
		}
	}

	@media (max-width: 600px) {
		.tier-section { 
			display: block; 
			position: relative;
		}

		.tier-section-field {
			display: flex;
			flex-direction: row;
		}

		.tier-section-control,
		.tier-section-field label {
			display: block;
		}

		.tier-section-field label {
			width: 100px;
		}

		.tier-section .remove-tier-btn {
			position: absolute;
			top: 0px;
			right: 5px;
		}
	}

	@media (max-width: 400px) {

		.tier-section-field {
			display: block;
		}

		.tier-section-field label {
			width: 100%;
			display: block;
		}

		.tier-section-control {
			width: 100%;
			display: block;
			margin-bottom: 5px;
		}
	}
	
</style>